import { IconButton } from '@mui/material';

import MenuPopover from '../MenuPopover';
import { IconEllipsisVertical } from 'src/libraries/icons';

//
//

type Props = {
  actions: React.ReactNode;
  open?: HTMLElement | null;
  onClose?: VoidFunction;
  onOpen?: (event: React.MouseEvent<HTMLElement>) => void;
  disabled?: boolean;
};

export default function TableMoreMenu({ actions, open, onClose, onOpen, disabled }: Props) {
  if (!actions) {
    return (
      <IconButton disabled>
        <IconEllipsisVertical size={18} />
      </IconButton>
      );
  }

  return (
    <>
      <IconButton onClick={onOpen} disabled={disabled}>
        <IconEllipsisVertical size={18} />
      </IconButton>

      <MenuPopover
        open={Boolean(open)}
        anchorEl={open}
        onClose={onClose}
        onClick={onClose}
        anchorOrigin={{ vertical: 'top', horizontal: 'left' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
        arrow="right-top"
        PaperProps={{
          sx: { border: (theme) => `1px solid ${theme.palette.grey[300]}` },
        }}
        sx={{
          mt: -1,
          width: 160,
          '& .MuiMenuItem-root': {
            px: 1,
            typography: 'body2',
            borderRadius: 0.75,
            '& svg': { mr: 2, width: 20, height: 20 },
          },
        }}
      >
        {actions}
      </MenuPopover>
    </>
  );
}
